import { EnumResolver } from "../../../common/tables/etc/EnumResolver";
import {
    CostPayoutModifierTableRow
} from "../../../../../common/tables/cost-payout-modifier/CostPayoutModifierTableRow";
import { EnumMapper } from "../../../common/tables/etc/EnumMapper";

export class CPMEnumMapper extends EnumResolver<CostPayoutModifierTableRow> {
    public resolveEnum(_columnName: keyof CostPayoutModifierTableRow): EnumMapper {
        return {} as EnumMapper;
    }
}
